import { createApiCall, MethodType, URI } from "../Api";
import { ForgotPasswordData } from "models/forgotPassword";

export const fetchForgotPassword = (payload: ForgotPasswordData) => {
  return createApiCall(MethodType.PUT, URI.AUTH.FORGOT_PASSWORD, payload);
};
